import React from 'react';
import { i18n } from '../../i18n/translate';
import { getActiveRuleSetFromUrl } from '../../utils/UrlUtil';
import { SelectFilter } from '../Filters/SelectFilter';

interface RuleSet {
  active?: boolean;
  interstitial_redirect?: string;
  name: string;
}

interface RoleOption {
  ruleSet: string;
  name: string;
  label: string;
  shortLabel: string;
}

interface SidebarRoleSwitcherProps {
  currentRuleSets?: RuleSet[];
  onMenuClose?: () => void;
  onMenuOpen?: () => void;
  onSelectRuleSet?: (ruleSetName: string) => void;
}

const ROLE_OPTIONS: RoleOption[] = [
  {
    ruleSet: 'cc_admin',
    name: 'cc_admin',
    label: i18n.t('Employees'),
    shortLabel: i18n.t('Employees'),
  },
  {
    ruleSet: 'scorm_manager',
    name: 'scorm_manager',
    label: i18n.t('Scorm'),
    shortLabel: i18n.t('Scorm'),
  },
];

const getSkipRoleSelectionValue = (): boolean => {
  if (typeof document !== 'undefined') {
    return !!document?.querySelector('[data-skip-role-selection="true"]');
  }
  return false;
};

export const SidebarRoleSwitcher: React.FC<SidebarRoleSwitcherProps> = ({
  currentRuleSets = [],
  onMenuClose,
  onMenuOpen,
  onSelectRuleSet,
}) => {
  const activeRuleSet = getActiveRuleSetFromUrl(currentRuleSets);
  const availableRuleSets = ROLE_OPTIONS.filter(roleOption =>
    currentRuleSets.some(currentRuleSet => currentRuleSet.name === roleOption.ruleSet)
  );
  const defaultRuleSet = availableRuleSets.find(roleOption => roleOption.ruleSet === activeRuleSet?.name);

  const onChange = (selectedRuleSet: RoleOption) => {
    if (onSelectRuleSet) onSelectRuleSet(selectedRuleSet.name);
  };

  if (getSkipRoleSelectionValue() || (activeRuleSet?.name && !defaultRuleSet) || availableRuleSets.length < 2) {
    return null;
  } else {
    if (defaultRuleSet) {
      return (
        <li
          className="sidebar-role-switcher"
          data-object-type="sidebar-role-switcher"
          data-action="sidebar-role-switcher"
        >
          <SelectFilter
            defaultValue={defaultRuleSet}
            isClearable={false}
            onChange={onChange}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            options={availableRuleSets}
            selectedKey="shortLabel"
            showSelected={true}
            valueKey="ruleSet"
          />
        </li>
      );
    } else {
      return null;
    }
  }
};

SidebarRoleSwitcher.displayName = 'SidebarRoleSwitcher';
